import { LEAD_STATUS_LABELS, type LeadStatus } from '@marketing-hub/shared';
import styles from './StatusBadge.module.css';

const VARIANT: Partial<Record<LeadStatus, keyof typeof styles>> = {
  new: 'new',
  replied: 'replied',
  team: 'replied',
  partnership: 'replied',
  rejected: 'bounce',
};

export function StatusBadge({ status }: { status: string }) {
  const key = status as LeadStatus;
  const label = LEAD_STATUS_LABELS[key] ?? status;
  const variant = VARIANT[key] ?? 'default';
  return <span className={`${styles.badge} ${styles[variant]}`}>{label}</span>;
}
